<template>
	<div id="text-page" data-aos="fade">
		<!-- Top -->
		<section class="top-section">
			<div class="container">
				<div class="row">
					<div class="col-12 col-lg-10 col-xl-8 mx-auto">
						<p class="hero-eyebrow">Legal</p>
						<h1 class="hero-title">Aviso de Privacidad</h1>
						<p class="hero-date">Última actualización: Enero 2025</p>
					</div>
				</div>
			</div>
		</section>

		<!-- Contenido -->
		<section class="content-section">
			<div class="container">
				<div class="row">
					<div class="col-12 col-lg-10 col-xl-8 mx-auto">
						<b-card class="terms-card" body-class="terms-card-body">
							<div class="terms-block">
								<h2 class="terms-heading">1. Responsable del Tratamiento de Datos</h2>
								<p class="terms-text">
									unlawk, con domicilio en Ciudad de México, México, es responsable del tratamiento de sus datos
									personales. Nos comprometemos a proteger su privacidad y garantizar el uso adecuado de su información
									personal de acuerdo con la Ley Federal de Protección de Datos Personales en Posesión de los
									Particulares.
								</p>
							</div>

							<div class="terms-block">
								<h2 class="terms-heading">2. Datos Personales Recopilados</h2>
								<p class="terms-text mb-3">
									Para proporcionarle nuestros servicios, recopilamos los siguientes tipos de información:
								</p>
								<ul class="terms-list">
									<li>
										<strong>Datos de identificación:</strong> Nombre completo, fecha de nacimiento, RFC
									</li>
									<li>
										<strong>Datos de contacto:</strong> Dirección, correo electrónico, teléfono
									</li>
									<li>
										<strong>Datos de cuenta:</strong> Nombre de usuario, contraseña encriptada
									</li>
									<li>
										<strong>Datos de caso legal:</strong> Descripción del asunto, documentos relacionados
									</li>
									<li>
										<strong>Datos de uso:</strong> Historial de búsquedas, preferencias, interacciones con la plataforma
									</li>
								</ul>
							</div>

							<div class="terms-block">
								<h2 class="terms-heading">3. Finalidades del Tratamiento</h2>
								<p class="terms-text mb-3">
									Utilizamos sus datos personales para las siguientes finalidades:
								</p>
								<ul class="terms-list">
									<li>Facilitar la conexión entre usuarios y profesionales legales</li>
									<li>Procesar solicitudes de consulta y seguimiento de casos</li>
									<li>Mejorar nuestros servicios mediante análisis de uso</li>
									<li>Enviar notificaciones importantes sobre su cuenta y servicios</li>
									<li>Cumplir con obligaciones legales y regulatorias</li>
									<li>Prevenir fraudes y garantizar la seguridad de la plataforma</li>
								</ul>
							</div>

							<div class="terms-block">
								<h2 class="terms-heading">4. Compartición de Datos</h2>
								<p class="terms-text">
									unlawk no vende ni renta sus datos personales a terceros. Compartimos información únicamente con los
									abogados y firmas legales que usted seleccione para consultas, y con proveedores de servicios que nos
									ayudan a operar la plataforma (hosting, procesamiento de pagos, análisis), quienes están obligados a
									mantener la confidencialidad de su información.
								</p>
							</div>

							<div class="terms-block">
								<h2 class="terms-heading">5. Medidas de Seguridad</h2>
								<p class="terms-text mb-3">
									Implementamos medidas técnicas y organizativas para proteger sus datos personales:
								</p>
								<ul class="terms-list">
									<li>Encriptación SSL/TLS para todas las transmisiones de datos</li>
									<li>Almacenamiento seguro con cifrado de bases de datos</li>
									<li>Controles de acceso estrictos y autenticación de dos factores</li>
									<li>Auditorías de seguridad regulares</li>
									<li>Capacitación continua del personal en protección de datos</li>
								</ul>
							</div>

							<div class="terms-block">
								<h2 class="terms-heading">6. Derechos ARCO</h2>
								<p class="terms-text mb-3">Usted tiene derecho a:</p>
								<ul class="terms-list">
									<li>
										<strong>Acceder</strong> a sus datos personales en nuestro poder
									</li>
									<li>
										<strong>Rectificar</strong> datos inexactos o incompletos
									</li>
									<li>
										<strong>Cancelar</strong> sus datos cuando considere que no son necesarios
									</li>
									<li>
										<strong>Oponerse</strong> al tratamiento de sus datos para fines específicos
									</li>
								</ul>
								<p class="terms-text mt-3">
									Para ejercer estos derechos, puede enviar una solicitud a privacidad@unlawk.com con su identificación
									oficial y descripción clara de su petición.
								</p>
							</div>

							<div class="terms-block">
								<h2 class="terms-heading">7. Cookies y Tecnologías Similares</h2>
								<p class="terms-text">
									Utilizamos cookies y tecnologías similares para mejorar su experiencia de usuario, analizar el tráfico
									del sitio y personalizar contenido. Puede configurar su navegador para rechazar cookies, aunque esto
									puede afectar la funcionalidad de ciertos servicios.
								</p>
							</div>

							<div class="terms-block">
								<h2 class="terms-heading">8. Retención de Datos</h2>
								<p class="terms-text">
									Conservamos sus datos personales durante el tiempo necesario para cumplir con las finalidades
									descritas y cumplir con obligaciones legales. Los datos de casos pueden conservarse por un período
									mínimo de 5 años conforme a las regulaciones aplicables.
								</p>
							</div>

							<div class="terms-block">
								<h2 class="terms-heading">9. Transferencias Internacionales</h2>
								<p class="terms-text">
									En caso de que sus datos sean transferidos a países fuera de México, garantizamos que dichas
									transferencias cumplan con los estándares de protección adecuados mediante cláusulas contractuales
									aprobadas o certificaciones de privacidad reconocidas.
								</p>
							</div>

							<div class="terms-block">
								<h2 class="terms-heading">10. Cambios al Aviso de Privacidad</h2>
								<p class="terms-text">
									Nos reservamos el derecho de modificar este Aviso de Privacidad en cualquier momento. Las
									modificaciones estarán disponibles en nuestra plataforma y le notificaremos por correo electrónico
									sobre cambios significativos.
								</p>
							</div>

							<div class="terms-block mb-0">
								<h2 class="terms-heading">11. Contacto</h2>
								<p class="terms-text">
									Para cualquier duda sobre este Aviso de Privacidad o el tratamiento de sus datos:
								</p>
								<ul class="terms-contact list-unstyled">
									<li>
										<i class="fa-regular fa-envelope"></i>
										Email: privacidad@unlawk.com
									</li>
									<li>
										<i class="fa-regular fa-phone"></i>
										Teléfono: +52 (55) 1234-5678
									</li>
									<li>
										<i class="fa-regular fa-location-dot"></i>
										Dirección: Ciudad de México, México
									</li>
								</ul>
							</div>
						</b-card>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
export default {
	mounted() {
	}
}
</script>
